import { useAuthStore } from '@/stores/authStore.js';
import { useUserStore } from '@/stores/userStore.js';
import * as routeFunctions from '@/helpers/routeFunctions.js';
import { getActivePinia } from 'pinia';

export function fetchExistingToken() {
    let localStorageToken = localStorage.getItem('access_token');
    const authStore = useAuthStore();
    let authStoreToken = authStore.token;

    //if an existing token exists in the local storage but not in the AuthStore then it needs to be applied to the AuthStore
    //so the entire application can use it
    if (localStorageToken != '' && authStoreToken == '') {
        // debugLog('helpers/authFunctions/fetchExistingToken : authStoreToken NOT found.');
        // debugLog('helpers/authFunctions/fetchExistingToken : localStorageToken found: ' + localStorageToken);
        // debugLog('helpers/authFunctions/fetchExistingToken : setting authStore token to localStorage token found');
        authStore.token = localStorageToken;
    }
}

export function isLoggedIn() {
    let localStorageToken = localStorage.getItem('access_token');
    const authStore = useAuthStore();
    let authStoreToken = authStore.token;

    return !!localStorageToken && !!authStoreToken;
}

export async function validateCurrentToken() {
    const authStore = useAuthStore();

    if (authStore.token) {
        // debugLog('helpers/authFunctions/validateCurrentToken : existing token: ' + authStore.token);
        // debugLog('helpers/authFunctions/validateCurrentToken : before allowing a token to be used this is where the token will be verified');
        // debugLog('helpers/authFunctions/validateCurrentToken : ping the oauth endpoint with the token to return the validity of it');

        const userStore = useUserStore();

        let isValidToken = false;

        await userStore.me().then(() => {
            // debugLog('helpers/authFunctions/validateCurrentToken : token is valid');
            isValidToken = true;
        });

        return isValidToken;
    }

    return false;
}

export async function clearStores(path) {
    const excludedStores = ['applicationStore'];

    // debugLog('helpers/authFunctions.js - clearStores triggered');
    localStorage.removeItem('access_token');

    getActivePinia()._s.forEach((store) => {
        if (!excludedStores.includes(store.$id)) {
            store.$reset();
        }
    });

    if (path === 'profile') routeFunctions.navigateTo('auth.login');
}

export function getBrowserId() {
    let browserId = localStorage.getItem('browser_id');
    if (!browserId) {
        browserId = crypto.randomUUID();
        localStorage.setItem('browser_id', browserId);
    }
    return browserId;
}
